import React from "react";
import { MapPin } from "lucide-react";

/**
 * Connected origin → destination row, matching the "Trussville, Alabama /
 * South San Francisco, California" list style. Reused on the Load Board,
 * Saved Loads, and My Jobs list views so routes always read the same way.
 */
export default function RouteRow({ from, to, compact = false }) {
  return (
    <div className={`relative bg-gray-50 rounded-xl border border-gray-100 ${compact ? "p-2.5" : "p-3"}`}>
      <div className="space-y-2.5 relative">
        <div className="flex items-start gap-3 relative z-10">
          <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center shrink-0 border border-white">
            <div className="w-2 h-2 rounded-full bg-blue-600" />
          </div>
          <p className="text-sm font-bold text-gray-800 leading-snug">{from}</p>
        </div>
        <div className="absolute left-[9px] top-5 bottom-[18px] w-0.5 bg-gray-200 z-0" />
        <div className="flex items-start gap-3 relative z-10">
          <div className="w-5 h-5 rounded-full bg-teal-100 flex items-center justify-center shrink-0 border border-white">
            <MapPin className="w-3 h-3 text-teal-600" />
          </div>
          <p className="text-sm font-bold text-gray-800 leading-snug">{to}</p>
        </div>
      </div>
    </div>
  );
}
